import { useQuery } from "@tanstack/react-query";
import { DiscountsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { useAccessToken } from "@/hooks";

interface UseDiscountGetProps {
  id: string;
  enabled?: boolean;
}

export const useDiscountGet = ({ id, enabled = true }: UseDiscountGetProps) => {
  const accessToken = useAccessToken();

  const { data, isError, isLoading, isSuccess, isPending, refetch } = useQuery({
    queryKey: [QueryKeys.Discount, id],
    queryFn: async () => {
      if (!accessToken) {
        throw new Error("Authentication token is required");
      }
      const service = createAuthenticatedApi(DiscountsApi, accessToken);
      return service.getDiscountById({ id });
    },
    enabled: enabled !== false && !!accessToken && !!id,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data,
    isError,
    isLoading,
    isSuccess,
    isPending,
    refetch,
  };
};